import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PortalApp } from './PortalApp';
import '../theme/tailwind.css';

/**
 * Entry point for the Partner Deals Portal — a genuinely SEPARATE app from
 * the CRM SPA (`src/main.tsx`), built as a second Vite entry in this SAME
 * `frontend/` package (see `frontend/portal.html` + `vite.config.ts`'s
 * `build.rollupOptions.input`). Deliberately minimal relative to the CRM's
 * own `main.tsx`: no OTel web telemetry, New Relic, Coralogix RUM, or MSW
 * dev-mock bootstrap — none of that CRM-specific observability/dev-tooling
 * wiring applies to this standalone rep-facing app; it reuses only the
 * shared MUI theme + `shared/ui` kit (see `PortalApp.tsx`).
 */
const container = document.getElementById('root');
if (!container) {
  throw new Error('Portal root element (#root) not found');
}

createRoot(container).render(
  <StrictMode>
    <PortalApp />
  </StrictMode>,
);
